import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { ArrowUpRight, Home as HomeIcon } from "lucide-react";

const COPY = {
  ar: {
    tag: "404",
    title: "الصفحة التي تبحث عنها لم تعد موجودة",
    sub: "قد يكون الرابط قديماً أو تم نقل المحتوى. لنعيدك إلى المسار الصحيح.",
    home: "الرئيسية",
    work: "أعمالنا",
    blog: "المدونة",
    contact: "تواصل",
  },
  en: {
    tag: "404",
    title: "The page you're looking for no longer exists",
    sub: "The link may be outdated or the content has moved. Let's get you back on track.",
    home: "Home",
    work: "Our Work",
    blog: "Blog",
    contact: "Contact",
  },
};

const NotFound = () => {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;

  // Set proper SEO signals: noindex so Google removes this from its index
  useEffect(() => {
    document.title = `404 — ${c.title} · ARTLENSS`;
    // Replace robots meta with noindex
    let m = document.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
    }
    const previous = m.getAttribute("content");
    m.setAttribute("content", "noindex, follow");
    // Restore when leaving the 404 page
    return () => { if (previous) m.setAttribute("content", previous); };
  }, [c.title]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-24" data-testid="not-found-page">
      <div className="max-w-2xl text-center">
        <div className="font-display text-[#E6A95B] text-8xl md:text-9xl leading-none mb-4">{c.tag}</div>
        <h1 className="display-h2 mb-6">{c.title}</h1>
        <p className="text-white/60 text-lg leading-relaxed mb-10">{c.sub}</p>
        <div className="flex flex-wrap items-center gap-3 justify-center">
          <Link to="/" className="btn-primary" data-testid="notfound-home">
            <HomeIcon className="w-4 h-4" /> {c.home}
          </Link>
          <Link to="/work" className="btn-ghost" data-testid="notfound-work">
            {c.work} <ArrowUpRight className="w-4 h-4" />
          </Link>
          <Link to="/blog" className="btn-ghost" data-testid="notfound-blog">
            {c.blog} <ArrowUpRight className="w-4 h-4" />
          </Link>
          <Link to="/contact" className="btn-ghost" data-testid="notfound-contact">
            {c.contact} <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
